import cx from 'classnames';

import { VRM } from '@motorway/mw-highway-code/alpha';

import { useVehicle } from '@motorway/motorway-handshake-components';

import { getVehicleImage } from '../../helpers';
import { HandshakePhoto } from '../HandshakePhoto/HandshakePhoto';

import styles from './VehicleCard.module.scss';

export const VehicleCard = ({ padding = true }) => {
  const { vehicle: { enquiry } } = useVehicle();
  const { vehicleImages } = enquiry ?? {};
  const { vehicle, vehicleDetails } = enquiry ?? {};

  const imageUrl = getVehicleImage(vehicleImages);

  if (!vehicleDetails?.prettyVrm) {
    return null;
  }

  return (
    <div className={cx(styles.component, { [styles.padding]: padding })}>
      {imageUrl && <HandshakePhoto className={styles.handshakePhoto} url={imageUrl} />}
      <div>
        <VRM size="small" text={vehicleDetails?.prettyVrm} />
        <p>
          {vehicle?.make?.name}
          {' '}
          {vehicle?.model}
        </p>
      </div>
    </div>
  );
};
